// Barevné tóny pro celý admin (rozhodnutí 4. 9. 2026, fáze 4a).
//
// Do 4. 9. 2026 měl skoro každý soubor vlastní tabulku barev: PRIORITY_META,
// KATEGORIE_BARVA, DEADLINE_TONE, COLUMNS, PINNED_GROUPS, TYP_META,
// STATUS_PILL, PRIO_PILL, ACCENTS, QX_COLORS. Tohle je jediný zdroj pravdy.
//
// Sedm tónů, nic víc. Barvy mimo tuhle sadu (indigo, teal, yellow, red,
// violet, slate-800) se v aplikaci už nepoužívají.

export const TONY = {
  neutralni: { pilulka: "bg-slate-100 text-slate-600", plny: "bg-slate-400", pole: "bg-slate-100 text-slate-500", text: "text-slate-600" },
  znacka:    { pilulka: "bg-brand-100 text-brand-deep", plny: "bg-brand", pole: "bg-brand-100 text-brand-deep", text: "text-brand-deep" },
  ok:        { pilulka: "bg-emerald-50 text-emerald-700", plny: "bg-emerald-500", pole: "bg-emerald-50 text-emerald-600", text: "text-emerald-700" },
  pozor:     { pilulka: "bg-amber-50 text-amber-700", plny: "bg-amber-500", pole: "bg-amber-50 text-amber-600", text: "text-amber-700" },
  problem:   { pilulka: "bg-rose-50 text-rose-700", plny: "bg-rose-500", pole: "bg-rose-50 text-rose-600", text: "text-rose-700" },
  info:      { pilulka: "bg-sky-50 text-sky-700", plny: "bg-sky-500", pole: "bg-sky-50 text-sky-600", text: "text-sky-700" },
  zlata:     { pilulka: "bg-brand-gold/25 text-brand-950", plny: "bg-brand-gold", pole: "bg-brand-gold/25 text-brand-950", text: "text-brand-950" },
};

/** Vrátí tón, neznámý název spadne na neutrální. */
export function ton(klic) {
  return TONY[klic] || TONY.neutralni;
}

/* --------------------------------------------------------------------------
   Mapování významů na tóny. Stránky si nesmí vymýšlet vlastní barvy, jen se
   ptají "jaký tón má vysoká priorita" a dostanou odsud odpověď.
   -------------------------------------------------------------------------- */

/** Priorita úkolu: High / Medium / Low (v datech i česky). */
export const TON_PRIORITY = {
  High: "problem", Vysoká: "problem", vysoka: "problem",
  Medium: "pozor", Střední: "pozor", stredni: "pozor",
  Low: "neutralni", Nízká: "neutralni", nizka: "neutralni",
};

/** Sloupec boardu a pevné skupiny úkolů. */
export const TON_STATUS = {
  zasobnik: "neutralni",
  prioritni: "problem",
  mesicni: "info",
  tydenni: "znacka",
  v_procesu: "ok",
  hotovo: "ok",
  archiv: "neutralni",
  kontrola: "pozor",
};

/** Termín úkolu. */
export const TON_DEADLINE = {
  overdue: "problem",
  today: "pozor",
  future: "neutralni",
  neutral: "neutralni",
};

/** Typ meetingu. */
export const TON_TYP_MEETINGU = {
  tydenni: "znacka",
  mesicni: "info",
  kvartalni: "pozor",
  rocni: "ok",
};

/** Role v poznámkách a zápisu z meetingu. */
export const TON_ROLE = {
  owner: "znacka",
  ceo: "znacka",
  csm: "ok",
  manager: "info",
};

/** Kvadranty time reportu. */
export const TON_KVADRANT = { Q1: "problem", Q2: "ok", Q3: "pozor", Q4: "neutralni" };
